import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { Router } from '@angular/router';
import { Session } from 'src/app/interfaces/session-data';
import { OzowInitiateResponse, OzowPaymentUpdateRequest } from 'src/app/interfaces/ozow/ozow';
import { OzowService } from 'src/app/services/ozow/ozow.service';
import { SessionService } from 'src/app/services/session/session.service';

@Component({
  selector: 'app-ozow-version-two',
  templateUrl: './ozow.component.html',
  styleUrls: ['./ozow.component.scss']
})
export class OzowComponent implements OnInit, OnDestroy {
  redirectUrl;
  controllerUrl;
  loading = true;
  ozowInitiateResponse: OzowInitiateResponse;

  // Loader
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'determinate';
  value = 50;
  diameter = 75;

  //Countdown
  config = { leftTime: 5, format: 's' };
  hidePgLogo = false;
  sessionData: Session;

  // iframe
  public iframeLoaded:boolean;
  public iframePostback:boolean;
  private boundHandleIframeLoad:any;

  constructor(
    private ozowService: OzowService,
    private router: Router,
    private sessionService:SessionService,
  ) {
    sessionStorage.setItem('selected-payment', 'eft_ozow');
    this.boundHandleIframeLoad = this.handleIframeLoad.bind(this);
  }
  ngOnDestroy(): void {
    window.removeEventListener('message', this.boundHandleIframeLoad);
  }

  ngOnInit(): void {
    this.iframeLoaded = false;
    this.iframePostback = false;
    this.sessionData = JSON.parse(sessionStorage.getItem('sessionData'));
    this.hidePgLogo = this.sessionData?.sessionDisplayInformation?.hidePgLogo === 'true';
    window.addEventListener('message',this.boundHandleIframeLoad , false);
    this.submitForm();
  }

  private handleIframeLoad(event: MessageEvent) {
    console.log(event);
    // Check if the message is from the expected origin
    if(!/^https:\/\/(?:[a-zA-Z0-9-]+\.)*adumoonline\.com(\/|$)/.test(event.origin)) return;

    // Handle the response from the iframe
    if (event.data.status === 'COMPLETED' && event.data.paymethod==='OZOW') {
      // Redirect the parent window
      this.iframeLoaded = false;
      this.iframePostback = true;
      const ozowPaymentUpdateRequest: OzowPaymentUpdateRequest = event.data.payload;
      this.ozowService.update(sessionStorage.getItem('sessionToken'), ozowPaymentUpdateRequest)
      .subscribe(
        value => {
          setTimeout(()=>{
            this.navigateToStatus();
          }, 3000);
        }, (err: HttpErrorResponse) => {
          this.navigateToStatus();
        }
      );
    }
  }

  navigateToStatus() {
    this.loading = false;
    this.router.navigate([`${this.sessionService.getVirtualTwoBaseurl()}/transaction-status`]);
  }

  iframeOnLoad(event:any){
    if(!this.iframePostback){
      this.iframeLoaded = true;
    }
  }

  private submitForm() {
    this.ozowService.initializePayment(sessionStorage.getItem('sessionToken')).subscribe((data: OzowInitiateResponse) => {
      this.ozowInitiateResponse = data;
      setTimeout(() => {
        const ozowForm = (document.getElementById('ozow-form') as HTMLFormElement);
        ozowForm.submit();
      }, 450);
    }, (err: HttpErrorResponse) => {
      this.navigateToStatus();
    });
  }
}
